<template>

  <div class="table-paginator">

    <spinner v-if="loading" />

    <template v-else>

      <b-row class="justify-content-end">

        <b-col lg="5">

          <fieldset class="form-group">
            <div tabindex="-1" role="group">
              <div role="group" class="input-group">
                <div class="input-group-prepend">
                  <button type="button" class="btn btn-primary" @click="refresh()">
                    <i class="fa fa-search"></i> Buscador
                  </button>
                </div>
                <input type="text" v-model="term" @keyup.enter="refresh()" placeholder="Nombre de usuario, correo, teléfono, etc..." class="form-control">
              </div>
            </div>
          </fieldset>

        </b-col>

      </b-row>

      <b-table responsive class="animated fadeIn" :dark="dark" :hover="hover" :striped="striped" :bordered="bordered"
        :small="small" :fixed="fixed" :items="items" :fields="captions" :per-page="perPage">

        <template #cell(foto)="data">
          <api-img :comp="data.value" :rowed="true" />
        </template>

        <template #cell(imagenes_id)="data">
          <api-img :comp="data.value" :rowed="true" />
        </template>

        <template #cell(imagenes_id_logo)="data">
          <api-img :comp="data.value" :rowed="true" />
        </template>

        <template #cell(imagenes_id_avatar)="data">
          <api-img :comp="data.value" :rowed="true" />
        </template>

        <template #cell(imagen_id)="data">
          <api-img :comp="data.value" :rowed="true" />
        </template>

        <template #cell(avatar)="data">
          <api-img :comp="data.value" :rowed="true" />
        </template>

        <template #cell(total)="data">
          {{data.value | currency}}
        </template>

        <template #cell(fecha)="data">
          {{data.value | humanizar_fecha_simple }}
        </template>

        <template #cell(created)="data">
          {{data.value | humanizar_fecha}}
        </template>

        <template #cell(modified)="data">
          {{data.value | humanizar_fecha}}
        </template>

          <template #cell(tipo_afiliado)="data">
            {{data.value | capitalize({ onlyFirstLetter: true })}}
          </template>

        <!-- TOOLING -->
        <template #cell(_)="data">
          <router-link :to="composeEditUri(data.item)" class="btn btn-primary btn-sm btn-primary">
            Detalle
          </router-link>
        </template>

      </b-table>

      <nav class="pb-1">
        <b-pagination v-model="currentPage" :total-rows="itemsCount" :per-page="perPage" align="center"
          prev-text="Anterior" next-text="Siguiente" />
      </nav>

      <hr>

      <p class="text-center pt-3">
        <strong>Página {{currentPage}} de {{Math.ceil(itemsCount / perPage)}}</strong> (Se muestran
        <strong>{{items.length}} registros</strong> de un total de {{itemsCount}})
      </p>

    </template>

  </div>

</template>

<script>
  import apiImg from '@/views/elements/api-img'
  import axios from 'axios'

  export default {
    name: 'table-paginator',
    inheritAttrs: false,
    components: { apiImg },
    props: {
      newItemName: {
        String,
        default: ''
      },
      editName: {
        String,
        default: ''
      },
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      tableUri: {
        type: String,
        default: () => ''
      },
      fields: {
        type: [Array, Object],
        default: () => []
      },
      avatarKeyName: {
        type: String,
        default: 'imagenes_id'
      },
      perPage: {
        type: Number,
        default: 25
      },
      dark: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        currentPage: 1,
        items: [],
        itemsCount: 0,
		loading: false,
		term: null
      }
    },
    computed: {
		sourceURI(){
			let init = (this.tableUri + "/" + this.perPage + "/" + this.currentPage);
			if(!!this.term){ init += ("/" + this.term)}
			else if(!this.term || this.term == 's') {init += ("/@")}
			return init
		},
		captions: function () { return this.fields },
		newItem() {
			return { name: this.newItemName }
		}
    },
    mounted() {
      this.refresh()
    },
    methods: {
		composeEditUri(item) {
			return {
				name: this.editName,
				params: item
			}
		},
		refresh() {
			this.items = []
			this.loading = true
			axios.get(this.sourceURI).then(response => {
				this.items 			= response.data.rows
				this.itemsCount 	= response.data.count
				this.loading 		= false
			})
		}
    },
    watch: {
      'tableUri'(a, b) {
        this.refresh()
      },
      'currentPage'(a, b) {
        this.refresh()
      }
    }
  }

</script>

<style lang="less">
  .table-paginator {
    .align-right {
      display: block;
      text-align: right;

      a {
        text-decoration: none;
      }
    }
  }

</style>
